import Main from '@/views/client/Main.vue'


function findGroup (groups, groupName) {
  return groups.findIndex(function (element) {
    return element['name'] === groupName
  }) >= 0
}

function whoItIs () {
  if (localStorage.user !== 'undefined' && localStorage.user) {
    let user = JSON.parse(localStorage.user)
    if (findGroup(user.groups, 'manager')) {
      return '/manager/clients'
    } else if (findGroup(user.groups, 'client')) {
      return '/client'
    }
  }
  return '/auth/login'
}

const generalRoute = {
  path: '/',
  name: 'Main',
  component: Main,
  login: 'main',
  redirect: whoItIs(),
}

export default generalRoute
